import OwnerSecurityComponent from "../components/OwnerSecurityComponent";

export default function OwnerSecurityScreen() {
  return <OwnerSecurityComponent />;
}
